import {
  Box,
  Button,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useLocation, useNavigate } from "react-router-dom";
import CartItems from "./CartItems";
import { openModal } from "../../redux/actions/actions";
import ShoppingCartMobileModal from "../Modal/ShoppingCartMobileModal";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import paperBackFirstImg from "../../assets/images/masks/paper-back-1.svg";
import paperBackSecondImg from "../../assets/images/masks/paper-back-2.svg";

import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -3,
    top: 13,
    border: `2px solid ${(theme.vars ?? theme).palette.background.paper}`,
    padding: "0 4px",
  },
}));

export default function CartHeader() {

  const { t } = useTranslation();

  const [selectedCartType, setSelectedCartType] = useState("products");
  const cartProducts = useSelector((state) => state.cart.products?.cart);
  const cartServices = useSelector((state) => state.cart.services?.cart);

  const [openedShoppingCart, setOpenedShoppingCart] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const mobileDevice = useSelector((state) => state.windowWidth.width);

  const cartRef = useRef();

  const handleOpenModal = (cartProducts) => {
    // Dispatch an action to open the modal, with the FilterModal component as the payload
    dispatch(
      openModal(
        <ShoppingCartMobileModal navigate={navigate} location={location} />
      )
    );
  };

  const handleOpenShoppingCart = () => {
    if (mobileDevice > 768) {
      setOpenedShoppingCart(!openedShoppingCart);
    } else {
      handleOpenModal(cartProducts);
    }
  };

  // Dış tıklamaları kontrol etmek için bir fonksiyon
  const handleClickOutside = (event) => {
    if (cartRef.current && !cartRef.current.contains(event.target)) {
      setOpenedShoppingCart(false);
    }
  };

  useEffect(() => {
    // Dış tıklamaları dinlemek için olay dinleyicisini ekleyin
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Component unmount edildiğinde olay dinleyicisini kaldırın
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlerDesktop = () => {
    if (mobileDevice > 768) {
      setOpenedShoppingCart(false);
    }
  };

  const dispatch = useDispatch();
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin

  // useEffect(() => {
  // }, [selectedCartType]);

  const calculateTotalQuantity = () => {
    let cartProductQuantity = 0;
    let cartServicesQuantity = 0;

    cartProducts.forEach((cartProduct) => {
      cartProductQuantity += cartProduct?.quantity || 0;
    });

    cartServices.forEach((cartService) => {
      cartServicesQuantity += cartService?.quantity || 0;
    });

    return cartProducts.length || cartServices.length
      ? Number(cartProductQuantity) + Number(cartServicesQuantity)
      : null;
  };

  const theme = useTheme();
  return (
    <>
      <Box
        ref={cartRef}
        sx={{
          position: "relative",
          marginLeft: { xs: 0, md: ".5rem" },
          // top: "4px",
        }}
      >
        <Box
          onClick={handleOpenShoppingCart}
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          {/* <ShoppingCartIcon
            sx={{
              fontSize: mobileDevice > 768 ? "32px" : "24px",
            }} */}
          {/* <Avatar
            sx={{
              width: 32,
              height: 32,
              backgroundColor: lightMode ? "#e5e7eb" : "#292929",
              marginRight: "12px",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            <img width={32} src={ShoppingCartIconImg} alt="" />
          </Avatar> */}

          <IconButton
            size="large"
            aria-label="cart"
            sx={{ p: 0, width: 48, height: 48 }}
          >
            <StyledBadge
              showZero={false}
              badgeContent={
                cartProducts?.length || cartServices?.length
                  ? calculateTotalQuantity()
                  : "0"
              }
              color="primary"
            >
              <ShoppingCartOutlinedIcon
                fontSize="medium"
                sx={{
                  color: lightMode ? "#292929" : "#9ca3af",
                }}
              />
            </StyledBadge>
          </IconButton>

          {/* {cartProducts?.length || cartServices?.length ? (
            <Box
              sx={{
                width: "22px",
                height: "22px",
                borderRadius: "100%",
                filter: lightMode && "drop-shadow(2px 2px 2px #707070)",
                position: "absolute",
                top: "-12px",
                right: "-12px",
                background: getTheme().palette.customRed.dark,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#ffffff",
                }}
              >
                {calculateTotalQuantity()}
              </Typography>
            </Box>
          ) : null} */}
        </Box>
        {openedShoppingCart && mobileDevice > 768 ? (
          <Box
            sx={{
              minWidth: "320px",
              minHeight: "max-content",
              width: "max-content",
              position: "absolute",
              top: "64px",
              right: "0",
              overflow: "hidden",
              borderRadius: "1rem",
              backgroundColor: `rgba(${lightMode ? "255 255 255" : "28 37 46"
                } / 0.9)`,
              backgroundImage: `url(${paperBackFirstImg}), url(${paperBackSecondImg})`,
              backgroundSize: "50%, 50%",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right top, left bottom",
              backdropFilter: "blur(20px)",
              transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
              outline: 0,
              // background: lightMode ? "#ededed" : "#121212",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                padding: "1.25rem",
                // backgroundColor: lightMode ? "#efefef" : "#242424",
                color: lightMode ? "#444" : "#ffffff",
                borderBottom: `1px dashed ${lightMode ? "#e9ecee" : "#333e47"}`,
              }}
            >
              {t("basket")}
            </Typography>
            <Box
              sx={{
                display: "flex",
                padding: "1rem",
                // backgroundColor: lightMode ? "#efefef" : "#242424",
                borderBottom: `1px dashed ${lightMode ? "#e9ecee" : "#333e47"}`,
              }}
            >
              <Box
                onClick={() => setSelectedCartType("services")}
                sx={{
                  width: "50%",
                  textAlign: "center",
                  padding: ".5rem",
                  cursor: "pointer",
                  borderRadius: "1rem",
                  boxShadow:
                    selectedCartType === "services"
                      ? "rgb(1 1 1 / 10%) 0px 2px 5px 2px"
                      : "unset",
                }}
              >
                <Typography variant="body1" color="primary">
                  {t("services")} ({cartServices?.length})
                </Typography>
              </Box>
              <Box
                onClick={() => setSelectedCartType("products")}
                sx={{
                  width: "50%",
                  textAlign: "center",
                  padding: ".5rem",
                  cursor: "pointer",
                  borderRadius: "1rem",
                  boxShadow:
                    selectedCartType === "products"
                      ? "rgb(1 1 1 / 10%) 0px 2px 5px 2px"
                      : "unset",
                }}
              >
                <Typography variant="body1" color="primary">
                  {t("products")} ({cartProducts?.length})
                </Typography>
              </Box>
            </Box>
            <Box sx={{ overflow: "auto", maxHeight: "50vh" }}>
              {selectedCartType === "products" ? (
                cartProducts.length ? (
                  cartProducts?.map((item, idx) => {
                    return (
                      <CartItems
                        item={item}
                        idx={idx}
                        serviceType={
                          selectedCartType === "products"
                            ? "products"
                            : "services"
                        }
                      />
                    );
                  })
                ) : (
                  <Box
                    sx={{
                      padding: "2rem",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        marginBottom: "1rem",
                        position: "relative",
                      }}
                    >
                      <ShoppingBasketIcon
                        sx={{
                          fontSize: "72px",
                          color: lightMode
                            ? theme.palette.primary.main
                            : "#ffffff",
                        }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        color: lightMode ? "#444" : "#ffffff",
                        fontSize: "24px",
                        textTransform: 'capitalize'
                      }}
                    >
                      {t("basketIsEmpty")}!
                    </Typography>
                  </Box>
                )
              ) : cartServices.length ? (
                cartServices?.map((item, idx) => {
                  return (
                    <CartItems
                      item={item}
                      idx={idx}
                      serviceType={
                        selectedCartType === "products"
                          ? "products"
                          : "services"
                      }
                    />
                  );
                })
              ) : (
                <Box
                  sx={{
                    padding: "2rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      marginBottom: "1rem",
                      position: "relative",
                    }}
                  >
                    <ShoppingBasketIcon
                      sx={{
                        fontSize: "72px",
                        color: lightMode
                          ? theme.palette.primary.main
                          : "#ffffff",
                      }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      textTransform: 'capitalize',
                      color: lightMode ? "#444" : "#ffffff",
                      fontSize: "24px",
                    }}
                  >
                    {t("basketIsEmpty")}!
                  </Typography>
                </Box>
              )}
            </Box>

            {selectedCartType === "products" ? (
              cartProducts.length ? (
                location.pathname === "/payment/shop" ? (
                  <Button
                    fullWidth
                    sx={{
                      textTransform: 'capitalize',
                      minHeight: "50px !important",
                      borderTopLeftRadius: 0,
                      background: `linear-gradient(90deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.light} 35%, ${theme.palette.primary.extraLight} 100%)`,
                      borderTopRightRadius: 0,
                    }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      navigate("/shop");
                      handlerDesktop();
                    }}
                  >
                    {t("continueToShopping")}
                  </Button>
                ) : (
                  <Button
                    fullWidth
                    sx={{
                      textTransform: 'capitalize',
                      minHeight: "50px !important",
                      borderTopLeftRadius: 0,
                      background: `linear-gradient(90deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.light} 35%, ${theme.palette.primary.extraLight} 100%)`,
                      borderTopRightRadius: 0,
                    }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      navigate("payment/shop");

                      handlerDesktop();
                    }}
                  >
                    {t("continueToPayment")}
                  </Button>
                )
              ) : (
                <Button
                  fullWidth
                  sx={{
                    textTransform: 'capitalize',
                    minHeight: "50px !important",
                    borderTopLeftRadius: 0,
                    background: `linear-gradient(90deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.light} 35%, ${theme.palette.primary.extraLight} 100%)`,
                    borderTopRightRadius: 0,
                  }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    navigate("/shop");

                    handlerDesktop();
                  }}
                >
                  {t("continueToShopping")}
                </Button>
              )
            ) : cartServices.length ? (
              location.pathname === "/payment/services" ? (
                <Button
                  fullWidth
                  sx={{
                    textTransform: 'capitalize',
                    minHeight: "50px !important",
                    borderTopLeftRadius: 0,
                    background: `linear-gradient(90deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.light} 35%, ${theme.palette.primary.extraLight} 100%)`,
                    borderTopRightRadius: 0,
                  }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    navigate("/additional-services/cleaning-services");
                    handlerDesktop();
                  }}
                >
                  {t("continueToShopping")}
                </Button>
              ) : (
                <Button
                  fullWidth
                  sx={{
                    textTransform: 'capitalize',
                    minHeight: "50px !important",
                    borderTopLeftRadius: 0,
                    background: `linear-gradient(90deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.light} 35%, ${theme.palette.primary.extraLight} 100%)`,
                    borderTopRightRadius: 0,
                  }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    navigate("payment/services");

                    handlerDesktop();
                  }}
                >
                  {t("continueToPayment")}
                </Button>
              )
            ) : (
              <Button
                fullWidth
                sx={{
                  textTransform: 'capitalize',
                  minHeight: "50px !important",
                  borderTopLeftRadius: 0,
                  background: `linear-gradient(90deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.light} 35%, ${theme.palette.primary.extraLight} 100%)`,
                  borderTopRightRadius: 0,
                }}
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("additional-services/cleaning-services");

                  handlerDesktop();
                }}
              >
                {t("continueToShopping")}
              </Button>
            )}

            {/* {cartProducts.length || cartServices.length ? (
              <Button
                fullWidth
                sx={{
                  minHeight: "50px !important",
                  borderTopLeftRadius: 0,
                  background: `linear-gradient(90deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.light} 35%, ${theme.palette.primary.extraLight} 100%)`,
                  borderTopRightRadius: 0,
                }}
                variant="contained"
                color="primary"
                onClick={() => {
                  if (selectedCartType === "products") {
                    if (
                      location.pathname === "/payment/shop" ||
                      location.pathname === "/payment/services"
                    ) {
                      navigate("shop");
                    } else {
                      navigate("payment/shop");
                    }
                  } else if (selectedCartType === "services") {
                    if (
                      location.pathname === "/payment/services" ||
                      location.pathname === "/payment/shop"
                    ) {
                      navigate("additional-services/cleaning-services");
                    } else {
                      navigate("payment/services");
                    }
                  }

                  handlerDesktop();
                }}
              >
                {location.pathname === "/payment/shop" ||
                location.pathname === "/payment/services"
                  ? `{t("continueToShopping")}`
                  : `Continue to Payment`}
              </Button>
            ) : (
              <Button
                fullWidth
                sx={{
                  minHeight: "50px !important",
                  borderTopLeftRadius: 0,
                  background: `linear-gradient(90deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.light} 35%, ${theme.palette.primary.extraLight} 100%)`,
                  borderTopRightRadius: 0,
                }}
                onClick={() => {
                  if (selectedCartType === "products") {
                    navigate("shop");
                  } else if (selectedCartType === "services") {
                    navigate("additional-services/cleaning-services");
                  }

                  handlerDesktop();
                }}
                // onClick={() => (navigate("shop"), handlerDesktop())}
                variant="contained"
                color="primary"
              >
                {t("continueToShopping")}
              </Button>
            )} */}
          </Box>
        ) : null}
      </Box>
    </>
  );
}
